<template>
  <div class="container">
    <My-Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="mainBox">
      <!-- 控制区域 :timeRange="timeRange"-->
      <div class="control_box">
        <Search-bar
          :timeRange="timeRange"
          :inputs="inputs"
          :selects="selects"
          :dateTime="dateTime"
          @search="search"
          @reset="search"
        />
        <div class="control_box_bottom">
          <a-button
            v-if="!reGetExportData"
            type="primary"
            :icon="ExportLoading ? 'loading' : 'printer'"
            @click="downloadExcel"
            :disabled="ExportLoading"
            >{{ ExportLoading ? "加载中.." : "导出" }}</a-button
          >
          <a-button v-else @click="getExportData">重新获取导出数据</a-button>
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="show_box">
        <a-table
          :columns="columns"
          :data-source="tableData"
          :loading="loading"
          :rowKey="(tableData) => tableData.id"
          :pagination="pagination"
          :scroll="{x:true}"
          @change="handleTableChange"
        >
          <span slot="nameRender" slot-scope="record">
            {{ record.sub_user.name }}
            <span v-if="record.sub_user.is_deleted==1" class="outer">离职</span>
          </span>
          <span slot="mealType" slot-scope="record">
            {{
              record.order_type == "2"
                ? "点餐"
                : record.order_type == "1"
                ? "时段报餐"
                : record.order_type == "3"
                ? "现场点餐"
                :""
            }}
          </span>
          <span slot="mealStatus" slot-scope="record">
            {{
              record.status == 1
                ? "待就餐"
                : record.status == 2
                ? "已就餐"
                : record.status == 3
                ? "已取消"
                : ""
            }}
          </span>
          <span slot="checkFn" slot-scope="record">
            {{
              record.verify_type == 1
                ? "系统验证"
                : record.verify_type == 2
                ? "用户验证"
                : record.verify_type == 3
                ? "食堂验证"
                : record.verify_type == 4
                ? "闸机扫码"
                : record.verify_type == 5
                ? "人脸验证"
                : ""
            }}
          </span>
          <span slot="updatedTime" slot-scope="record">
            {{ record.status == 2 ? record.updated_at : "未核销" }}
          </span>
          <template slot="action" slot-scope="record">
            <a-button
              :disabled="record.status == 3"
              type="link"
              @click="deleteType(record)"
            >退款</a-button>
          </template>
        </a-table>
      </div>
    </div>

    <a-modal v-model="visible" title="取消报餐" @ok="handleCancleMeal">
      <a-form-model
        :model="cancleParam"
        :rules="cancleRules"
        ref="cancleForm"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="审核人账号" prop="auditor">
          <a-input v-model="cancleParam.auditor" placeholder="审核人账号" />
        </a-form-model-item>
        <a-form-model-item label="审核人密码" prop="password">
          <a-input
            type="password"
            v-model="cancleParam.password"
            placeholder="审核人密码"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  orderDatagrid,
  orderExcelExport,
  auditorDatalist,
  officeDatalist,
  postDatalist,
  mealDatalist,

  getAudit,
  orderCancel,
} from "@/request/api";
//引入工具函数
import util from "@/utils/util";
//引入封装的组件
import SearchBar from "@/components/common/SearchBar.vue";
import MyBreadcrumb from "@/components/common/MyBreadcrumb.vue";
import moment from "moment";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SearchBar, MyBreadcrumb },
  data() {
    return {
      breadcrumbs: [
        {
          key: 0,
          title: "用餐管理",
        },
        {
          key: 1,
          title: "报餐明细",
        },
      ],
      inputs: [
        {
          placeholder: "姓名",
          model: "name",
          width: 100,
        },
        {
          placeholder: "手机号码",
          model: "mobile",
          width: 100,
        },
      ],
      selects: [
        {
          model: "office_id",
          placeholder: "部门",
          width: 200,
          options: [
            {
              key: "",
              value: "部门",
            },
          ],
        },
        {
          model: "post_id",
          placeholder: "职务",
          width: 100,
          options: [
            {
              key: "",
              value: "职务",
            },
          ],
        },
        {
          model: "meal_id",
          placeholder: "用餐时段",
          width: 100,
          options: [
            {
              key: "",
              value: "用餐时段",
            },
          ],
        },
        {
          model: "status",
          placeholder: "就餐状态",
          width: 100,
          options: [
            {
              key: "",
              value: "就餐状态",
            },
            {
              key: 1,
              value: "待就餐",
            },
            {
              key: 2,
              value: "已就餐",
            },
            {
              key: 3,
              value: "已取消",
            },
          ],
        },
      ],
      dateTime: {
        show: true,
      },
      timeRange: {
        show: true,
        placeholderStart: "开始时间",
        placeholderEnd: "结束时间",
        rangeLimit: true,
        disabledBeforeNov: true,
      },
      queryParam: {
        page: 1,
        repast_date: "",
        status: "",
        meal_id: "",
        post_id: "",
        office_id: "",
        name: "",
        mobile: "",
        is_old: "",
        begin_date: "",
        end_date: "",
      },
      tableData: [], //从接口请求回来并在js部分整理好的表格数据
      dataForExport: [],
      loading: false,
      ExportLoading: false,
      reGetExportData: false,
      columns: [
        {
          title: "用餐时段",
          key: "meal",
          dataIndex: "meal.title",
        },
        {
          title: "部门",
          key: "office",
          dataIndex: "sub_user.office.title",
        },
        {
          title: "职务",
          key: "post",
          dataIndex: "sub_user.post.title",
        },
        {
          title: "用餐类型",
          key: "data_from",
          scopedSlots: { customRender: "mealType" },
        },
        {
          title: "订单明细",
          key: "orderDetails",
          dataIndex: "orderDetails",
        },

        {
          title: "金额",
          key: "money",
          dataIndex: "money",
        },
        {
          title: "姓名",
          key: "realname",
          scopedSlots: { customRender: "nameRender" },
        },
        {
          title: "手机",
          key: "mobile",
          dataIndex: "sub_user.mobile",
        },
        {
          title: "用餐日期",
          key: "repast_date",
          dataIndex: "repast_date",
        },
        //备注字段无返回
        {
          title: "用餐状态",
          key: "status",
          scopedSlots: { customRender: "mealStatus" },
        },
        {
          title: "验证方式",
          key: "auto_check",
          scopedSlots: { customRender: "checkFn" },
        },
        {
          title: "报餐时间",
          key: "created_at",
          dataIndex: "created_at",
        },
        {
          title: "核销时间",
          key: "updated_at",
          scopedSlots: { customRender: "updatedTime" },
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          fixed: 'right'
        },
      ], // 表格的列配置
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
      nowDate: moment(this.getCurrentData(), "YYYY-MM-DD"),
      onlineData: "",
      visible: false,
      cancleParam: {
        id: "",
        auditor: "",
        password: "",
      },
      cancleRules: {
        auditor: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    moment,
    getCurrentData() {
      return new Date().toLocaleDateString();
    },
    //列表下载
    downloadExcel() {
      this.$confirm({
        title: "确定导出表格?",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          this.export2Excel();
        },
        onCancel: () => {},
      });
    },
    //数据写入excel
    export2Excel() {
      orderExcelExport(this.queryParam).then((res) => {
        util.acceptFileStream(res.data, "用餐数据.xls");
      });
    },
    //格式转换
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 刷新
    search(val) {
      this.queryParam = {
        page: 1,
        repast_date: val.currentDate,
        status: val.select.status === "" ? "" : val.select.status,
        meal_id: val.select.meal_id ? val.select.meal_id : "",
        post_id: val.select.post_id ? val.select.post_id : "",
        office_id: val.select.office_id ? val.select.office_id : "",
        name: val.input.name ? val.input.name : "",
        mobile: val.input.mobile ? val.input.mobile : "",
        begin_date: val.timeRange.startTime,
        end_date: val.timeRange.endTime,
      };
      if (
        new Date(this.queryParam.repast_date) < this.onlineData ||
        new Date(this.queryParam.begin_date) < this.onlineData
      ) {
        this.queryParam.is_old = 1;
      } else {
        this.queryParam.is_old = 0;
      }
      this.pagination.current = 1;
      this.getTableData();
      //this.getExportData();
    },
    // 刷新
    search2(val) {
      this.outSideParam = {
        page: 1,
        status: val.select.status === "" ? "" : val.select.status,
        meal_id: val.select.meal_id ? val.select.meal_id : "",
        mobile: val.input.mobile ? val.input.mobile : "",
        begin_date: val.timeRange.startTime,
        end_date: val.timeRange.endTime,
      };
      this.pagination2.current = 1;
      this.getOutSideOrders();
    },
    //获取导出的数据
    getExportData() {
      //请求不分页的数据
      this.ExportLoading = true;
      this.reGetExportData = false;
      this.queryParam.no_paging = 1;
      orderDatagrid(this.queryParam)
        .then((res) => {
          this.dataForExport = res.data.map((item) => {
            if (item.items instanceof Array && item.items.length>0) {
              let arr = [];
              item.info.forEach((element) => {
                let str = "";
                str = `${element.title}*${element.num}份`;
                arr.push(str);
              });
              if (arr.length > 1) {
                arr.join(",");
              }
              item.orderDetails = arr.toString();
            } else {
              item.orderDetails = `${item.meal.title}*${item.count}份`;
            }
            item = {
              ...item,
              status:
                item.status == 1
                  ? "待就餐"
                  : item.status == 2
                  ? "已就餐"
                  : item.status == 3
                  ? "已取消"
                  : "",
              updated_at: item.status == 2 ? item.updated_at : "未核销",
              data_from:
                item.data_from == "order"
                  ? "点餐"
                  : item.data_from == "meal"
                  ? "套餐"
                  : "",
              auto_check:
                item.auto_check == 1
                  ? "系统验证"
                  : item.auto_check == 2
                  ? "用户验证"
                  : item.auto_check == 3
                  ? "食堂验证"
                  : item.auto_check == 4
                  ? "闸机扫码"
                  : item.auto_check == 5
                  ? "人脸验证"
                  : "",
              money: item.money * 1,
            };
            return item;
          });
          this.ExportLoading = false;
          this.reGetExportData = false;
        })
        .catch((err) => {
          if (err.status == 500) {
            this.$message.error(
              "加载导出的数据超时，请点击重新获取导出数据按钮获取数据"
            );
            this.reGetExportData = true;
          }
        });
    },
    //获取表格数据
    getTableData() {
      this.loading = true;
      //获取分页的数据用于展示
      this.queryParam.no_paging = 0;
      orderDatagrid(this.queryParam).then((res) => {
        const pagination = { ...this.pagination };
        pagination.total = res.data.result.total;
        this.pagination = pagination;
        let items = res.data.result.items
        items.forEach((item) => {
          // 判断info信息是否数组
          if (item.items instanceof Array && item.items.length>0) {
            let arr = [];
            item.items.forEach((element) => {
              let str = "";
              str = `${element.title}*${element.num}份`;
              arr.push(str);
            });
            if (arr.length > 1) {
              arr.join(",");
            }
            item.orderDetails = arr.toString();
          } else {
            item.orderDetails = `${item.meal.title}*${item.count}份`;
          }
        });
        this.tableData = items;
      }).finally(()=>{
        this.loading = false;
      });
    },

    //分页
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.queryParam.page = pagination.current;
      this.getTableData();
    },

    //获取部门列表
    getOffices() {
      officeDatalist({ }).then((res) => {
        let items = res.data.result;
        for (var i in items) {
          this.selects[0].options.push({
            key: items[i].id,
            value: items[i].title,
          });
        }
      });
    },

    //获取职务列表
    getPosts() {
      postDatalist({}).then((res) => {
        let items = res.data.result;
        for (var i in items) {
          this.selects[1].options.push({
            key: items[i].id,
            value: items[i].title,
          });
        }
      });
    },

    //获取就餐时段列表
    mealtimeListFn() {
      mealDatalist({ }).then((res) => {
        let items = res.data.result;
        for (let i in items) {
          this.selects[2].options.push({
            key: items[i].id,
            value: items[i].title,
          });
        }
      });
    },

    //取消报餐
    deleteType(record) {
      this.cancleParam.id = record.id;
      auditorDatalist({ type: 2 }).then((res) => {
        let auditors = res.data.result;
        if (auditors && auditors.length>0) {
          this.visible = true;
        } else {
          this.$confirm({
            content: `确定取消该订单？`,
            onOk: () => {
              orderCancel({id: this.cancleParam.id})
                .then((res) => {
                  this.$message.success("取消成功");
                  // this.queryParam.page = 1;
                  // this.pagination.current = 1;
                  this.getTableData();
                  this.getExportData();
                })
                .catch((err) => {
                  if (err.status == 400) {
                    this.$message.error(err.data.msg);
                  } else {
                    let { errors } = err.data;
                    for (let i in errors) {
                      this.$message.error(errors[i][0]);
                    }
                  }
                });
            },
          });
        }
      });
    },

    handleCancleMeal() {
      this.$refs["cancleForm"].validate((valid) => {
        if (valid) {
          this.orderCancelFnWithParam();
        }
      });
    },

    orderCancelFnWithParam() {
      orderCancel({
        id: this.cancleParam.id,
        auditor: this.cancleParam.auditor,
        password: this.cancleParam.password,
      })
        .then((res) => {
          this.visible = false;
          this.$message.success("取消成功");
          this.getTableData();
          this.getExportData();
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  async created() {
    this.getTableData();
    this.getOffices();
    this.getPosts();
    this.mealtimeListFn();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.mainBox {
  .control_box {
    background-color: white;
    padding: 20px;
    .control_box_bottom {
      margin-top: 20px;
    }
  }
  .show_box {
    width: 100%;
    padding-top: 10px;
  }
}
</style>